import React, { useEffect } from "react";
import PublicNavBar from "../components/PublicNavBar";
import PublicFooter from "../components/PublicFooter";
import StudentsHero from "../components/students-public/StudentsHero";
import WhyChooseSection from "../components/students-public/WhyChooseSection";
import AudienceGoalsSection from "../components/students-public/AudienceGoalsSection";
import HowItWorksStudents from "../components/students-public/HowItWorksStudents";
import SuccessMetrics from "../components/students-public/SuccessMetrics";
import TestimonialsSection from "../components/students-public/TestimonialsSection";
import FaqsSection from "../components/students-public/FaqsSection";
import StudentsFinalCta from "../components/students-public/StudentsFinalCta";

export default function StudentsPublic() {
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, []);

  return (
    <div className="min-h-screen bg-white text-ink">
      <PublicNavBar primaryCta={{ to: "/signup?role=student", label: "Get started" }} />
      <StudentsHero />
      <WhyChooseSection />
      <AudienceGoalsSection />
      <HowItWorksStudents />
      <SuccessMetrics />
      <TestimonialsSection />
      <FaqsSection />
      <StudentsFinalCta />
      <PublicFooter />
    </div>
  );
}
